import React, { Component } from 'react'
import Amplify, {Auth, Hub} from 'aws-amplify';
import { trim } from 'lodash'
import AsyncStorage from '@react-native-async-storage/async-storage'
import awsConfig from '../../aws-exports';

Auth.configure(awsConfig);

export default (Wrapped) => class extends Component {

  constructor(props) {
    super(props)

    this.state = {
      email: null,
      password: null,
      needVerifCode: false,
      emailSignLoading: false,
      emailSignVerifCodeLoading: false
    }

    console.log(this)
  }

  async emailSign(_email) {
    const email = trim(_email)

    let password = await AsyncStorage.getItem('@last_signup_password');
    if(!password) {
      password = Math.random().toString(36).substring(2)
      await AsyncStorage.setItem('@last_signup_password', password)
    }

    console.log(password)

    this.setState( { email, password, emailSignLoading: true })

    try {
      const signup = await Auth.signUp({
        username: email,
        password: password,
        attributes: {
          email
        },
        validationData: []  //optional
      })

      this.setState({ needVerifCode: 'signUp' })
    }
    catch(e) {
      if(e.code == 'UsernameExistsException') {
        try {
          await Auth.forgotPassword(email)
          this.setState({ needVerifCode: 'forgot' })
        }
        catch(e) {
          // console.log(e)
          // CKTD
          alert('aaaa')
        }

      }
      else {
        alert(e.message)
      }
    }

    this.setState( { emailSignLoading: false })

  }

  async emailSignVerifCode(verifCode, clearFn) {
    this.setState( { emailSignVerifCodeLoading: true })
    const { email, password, needVerifCode } = this.state


    try {
      if(needVerifCode == 'signUp') {
        await Auth.confirmSignUp(email, verifCode, {
          forceAliasCreation: true
        })
      }
      else if(needVerifCode == 'forgot') {
        try {
          await Auth.forgotPasswordSubmit(email, verifCode, password)
        }
        catch(e) {
          await Auth.confirmSignUp(email, verifCode, {
            forceAliasCreation: true
          })
        }
      }

      await AsyncStorage.removeItem('@last_signup_password')

      await Auth.signIn(email, password)

      this.setState({ needVerifCode: false, emailSignVerifCodeLoading: false })

    } catch(e) {
      console.log(e)
      alert('bad code, retry !')
      this.setState({ emailSignVerifCodeLoading: false })
      if(clearFn) clearFn()
    }
  }

  render() {
    return <Wrapped emailSign={this.emailSign.bind(this)} emailSignVerifCode={this.emailSignVerifCode.bind(this)} {...this.state} {...this.props} />
  }

}
